import * as React from 'react';
import { Link } from 'react-router-dom';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';

export class ComingSoon extends React.Component<any, any> {
  public constructor(props) {
    super(props);
  }

  public render() {
    return (
      <>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell all-cell-1-1">
            <UitkText weight="bold" size={800} align="center">
              coming soon
            </UitkText>
          </div>
        </div>
      </>
    );
  }
}
